<template>
 <v-app>
  <div id="app"  style="margin-top:0px;">
    <AppHeader/>
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <UserDetails />
   
  </div>
   </v-app>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import UserDetails from './components/userDetails.vue'
import AppHeader from './components/common/appHeader.vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

export default {
  name: 'App',
  components: {
    // HelloWorld,
    AppHeader,
    UserDetails
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

</style>


